class RosayaaBanner extends HTMLElement {
	constructor() {
		super();
		this.init();
	}

	init() {
		// Event listeners voor responsive gedrag
		this.handleResize();
		window.addEventListener('resize', this.handleResize.bind(this));
		
		// Smooth scroll voor buttons
		this.initSmoothScroll();
	}

	handleResize() {
		// Responsive image switching wordt nu gedaan via CSS
		// Dit kan uitgebreid worden voor meer complexe responsive gedrag
	}

	initSmoothScroll() {
		const buttons = this.querySelectorAll('.rosayaa-banner__button');
		buttons.forEach(button => {
			button.addEventListener('click', (e) => {
				// Voeg smooth scroll toe als de link naar een sectie op dezelfde pagina verwijst
				const href = button.getAttribute('href');
				if (href && href.startsWith('#')) {
					e.preventDefault();
					const target = document.querySelector(href);
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						});
					}
				}
			});
		});
	}
}

// Registreer de custom element
customElements.define('rosayaa-banner', RosayaaBanner);
